import React from 'react';
import logo from '../../../imgs/NafesLogoCropped.png'



class AppHeader extends React.Component {



    render = () => {

        let { quizViwerModel, activity } = this.props
        return (
            <>
                <div id="app_header">
                    <div style={{ position: "relative", height: "100%", width: "100%" }}>


                        {
                            (quizViwerModel.callbackData.dev == "true") ?
                                <div style={{ textAlign: "center" }}>
                                    <span style={{ fontWeight: 300 }}>
                                        {/* {callbackData.topicTitle}({activity.activityKey}) */}
                                            ({activity.activityKey})
                                        </span>
                                </div>
                                :

                                ""
                        }



                        <div className="p-grid" style={{paddingTop:"20px"}}>
                            <div className="p-col-2" style={{ textAlign: "center" }}>04:11</div>
                            <div className="p-col-8" style={{ textAlign: "center" }}>{quizViwerModel.callbackData.topicTitle}</div>
                            <div className="p-col-2" style={{ textAlign: "right" , paddingRight:"15px" }}>&gt;</div>

                        </div>


                    </div>
                </div>

            </>
        )
    }
}


export default AppHeader